import { Component, Inject, OnInit } from '@angular/core';
import { StepSharedService } from '../stepshared.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { BookdemoComponent } from '../bookdemo/bookdemo.component';
import { UserSessionService } from 'bna-angular-auth-client';
import { SettingsService } from 'src/app/core/services/http/settings.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-onboarding-step-one-component',
  templateUrl: './onboarding-step-one-component.component.html',
  styleUrls: ['./onboarding-step-one-component.component.scss'],
})
export class OnboardingStepOneComponentComponent implements OnInit {
  videoLink: SafeResourceUrl;
  public readonly maintenanceAppUrl: string;
  constructor(
    private sanitizer: DomSanitizer,
    private sharedService: StepSharedService,
    private dialogRef: MatDialog,
    public userSessionService: UserSessionService,
    private settingsService: SettingsService,
    private router: Router,
    public dialogRefOnboardingStepOne: MatDialogRef<OnboardingStepOneComponentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      disableOnboardingFlow: boolean;
      isKeyManagerFirstLoggin: boolean;
      agencyName: string;
      promotionalVideoLink: string;
      isLeadOrgAdmin: boolean;
      isLeadOrgAdminComplete: boolean;
    }
  ) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.data.promotionalVideoLink
    );

    this.maintenanceAppUrl = this.userSessionService.addSessionQueryParams(
      `${environment.maintenanceApp.baseUrl}`
    );
  }

  ngOnInit(): void {
    let user = this.userSessionService.getProfile();
  }
  next() {
    if (this.data.disableOnboardingFlow) {
      this.saveIsKeyAutomateFirstLogging();
    } else {
      const nextStep = 2;
      this.sharedService.changeStep(nextStep);
    }
  }

  bookDemo() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '450px';
    dialogConfig.height = 'calc(100% - 3.5rem)';
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'bookdemo-dialog';

    dialogConfig.data = {
      agencyName: this.data.agencyName,
    };
    this.dialogRef.open(BookdemoComponent, dialogConfig);
  }

  saveIsKeyAutomateFirstLogging() {
    const formData = {
      IsKeyAutomateFirstLogging: true,
    };
    this.settingsService.IsKeyAutomateFirstLogging(formData).subscribe({
      next: (result) => {
        this.dialogRefOnboardingStepOne.close();
        if (!this.data.isLeadOrgAdmin) {
          this.router.navigate(['/calendar']);
        }
      },
      error: (error) => {},
    });
  }

  exitOnboarding() {}
}
